/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.replies.rpc.ReplyRecommendationsSettingsService
 */
import * as References from './ReplyRecommendationsSettingsService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.replies.rpc.ReplyRecommendationsSettingsService#updateSettingsV2
 */
export const UPDATE_SETTINGS_V2_MUTATION_FIELD_NAME = 'com_hubspot_cv_replies_rpc_ReplyRecommendationsSettingsService_updateSettingsV2';
export const UPDATE_SETTINGS_V2_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_SETTINGS_V2_MUTATION_FIELD_NAME,
  args: ['isEnabled', 'aiAgentUserId', 'aiAgentVersionId', 'lastUpdatedAt'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.updateSettingsV2Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.replies.rpc.ReplyRecommendationsSettingsService#getSettings
 */
export const GET_SETTINGS_QUERY_FIELD_NAME = 'com_hubspot_cv_replies_rpc_ReplyRecommendationsSettingsService_getSettings';
export const GET_SETTINGS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SETTINGS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getSettingsRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.replies.rpc.ReplyRecommendationsSettingsService#getSettingsV2
 */
export const GET_SETTINGS_V2_QUERY_FIELD_NAME = 'com_hubspot_cv_replies_rpc_ReplyRecommendationsSettingsService_getSettingsV2';
export const GET_SETTINGS_V2_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SETTINGS_V2_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getSettingsV2Rpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.replies.rpc.ReplyRecommendationsSettingsService#areReplyRecsEnabled
 */
export const ARE_REPLY_RECS_ENABLED_QUERY_FIELD_NAME = 'com_hubspot_cv_replies_rpc_ReplyRecommendationsSettingsService_areReplyRecsEnabled';
export const ARE_REPLY_RECS_ENABLED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: ARE_REPLY_RECS_ENABLED_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.areReplyRecsEnabledRpc, {
      timeout: ctx.timeout
    });
  }
});